import {
  materialCells,
  materialRenderers,
} from "@jsonforms/material-renderers";
import { appointmentPickerTester, arrayLayoutTester } from "../testers";
import AppointmentPickerRenderer from "./AppointmentPickerRenderer";
import ArrayRenderer from "./ArrayRenderer";
import DatePickerRenderer, { datePickerTester } from "./DatePickerRenderer";
import DataLabelRenderer, { dataLabelTester } from "./LabelRenderer";
import TimePickerRenderer, { timePickerTester } from "./TimePickerRenderer";
import InputWithAdornmentsRenderer, {
  inputWithAdornmentsTester,
} from "./InputWithAdornmentsRenderer";
import VisitPickerRenderer, {
  visitPickerTester,
} from "./VisitPickerRenderer/VisitPickerRenderer";
import PhoneNumberRenderer, { phoneNumberTester } from "./PhoneNumberRenderer";
import PhoneNumberWithCountryCodeRenderer, {
  phoneNumberWithCountryCodeTester,
} from "./PhoneNumberWithCountryCodeRenderer";
import NPIInputRenderer, { npiInputTester } from "./NPIInputRenderer";
import ICD10AutocompleteCell, {
  icd10AutocompleteCellTester,
} from "./ICD10AutocompleteCell";
import LabTestAutocompleteCell, {
  labTestAutocompleteCellTester,
} from "./LabTestAutocompleteCell";
import StylableMaterialArrayControlRenderer, {
  stylableMaterialArrayControlTester,
} from "./StylableMaterialArrayControlRenderer";
import MaterialTextCell, { materialTextCellTester } from "./MaterialTextCell";

const customRenderers = [
  ...materialRenderers,
  {
    tester: arrayLayoutTester,
    renderer: ArrayRenderer,
  },
  {
    tester: dataLabelTester,
    renderer: DataLabelRenderer,
  },
  {
    tester: datePickerTester,
    renderer: DatePickerRenderer,
  },
  {
    tester: timePickerTester,
    renderer: TimePickerRenderer,
  },
  {
    tester: appointmentPickerTester,
    renderer: AppointmentPickerRenderer,
  },
  {
    tester: inputWithAdornmentsTester,
    renderer: InputWithAdornmentsRenderer,
  },
  {
    tester: visitPickerTester,
    renderer: VisitPickerRenderer,
  },
  {
    tester: phoneNumberTester,
    renderer: PhoneNumberRenderer,
  },
  {
    tester: phoneNumberWithCountryCodeTester,
    renderer: PhoneNumberWithCountryCodeRenderer,
  },
  {
    tester: npiInputTester,
    renderer: NPIInputRenderer,
  },
  {
    tester: stylableMaterialArrayControlTester,
    renderer: StylableMaterialArrayControlRenderer,
  },
];

export const customCellRenderers = [
  ...materialCells,
  {
    tester: icd10AutocompleteCellTester,
    cell: ICD10AutocompleteCell,
  },
  {
    tester: labTestAutocompleteCellTester,
    cell: LabTestAutocompleteCell,
  },
  {
    tester: materialTextCellTester,
    cell: MaterialTextCell,
  },
];

export default customRenderers;
